import script from "./TooEarly.vue?vue&type=script&setup=true&lang=ts"
export * from "./TooEarly.vue?vue&type=script&setup=true&lang=ts"

import "./TooEarly.vue?vue&type=style&index=0&id=319b7793&scoped=true&lang=css"
script.__scopeId = "data-v-319b7793"

export default script